import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';
import getUserData from './UserData';

export default class ResultsDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.bg = null;
    this.bgSpeechTail = null;
    this.workingWidth = null;
    this.workingHeight = null;

    this.lblTitle = null;

    this.reportRowLabelsContainer = null;
    this.lblQuestions = null;
    this.lblFishCount = null;
    this.lblIsCorrect = null;

    this.questionNumColumn = null;
    this.fishCountColumn = null;
    this.isCorrectColumn = null;

    this.userdata = getUserData();

    this.workingWidth = 560;
    this.workingHeight = 600;
    this.bg = ABCyaPhaser.Graphics.addRoundedRect(0,0, this.workingWidth, this.workingHeight, 10, 0xffffff, this, { x: 0, y: 0 });

    this.bgSpeechTail = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._ResultsTail, this).setOrigin(0);
    this.bgSpeechTail.x = this.workingWidth - this.bgSpeechTail.width + 36;
    this.bgSpeechTail.y = this.workingHeight - 2;

    const txtColor = 0x006699;
    const fnt = FontKeys._bpreplaybold;
    this.lblTitle = ABCyaPhaser.Text.addText(this.workingWidth / 2, 35, 36, txtColor, fnt,`${ABCyaPhaser.Localization.instance.getLocalizedString('round')} ${this.userdata.currentRound}`, this, true).setOrigin(0.5);

    this.reportRowLabelsContainer = this.scene.add.container();

    this.lblQuestions = ABCyaPhaser.Text.addText(0,0, 28, txtColor, fnt,ABCyaPhaser.Localization.instance.getLocalizedString('results_page.question'), this.reportRowLabelsContainer, true).setOrigin(0.5);
    this.lblFishCount = ABCyaPhaser.Text.addText(0,0, 28, txtColor, fnt,ABCyaPhaser.Localization.instance.getLocalizedString('results_page.number'), this.reportRowLabelsContainer, true).setOrigin(0.5);
    this.lblIsCorrect = ABCyaPhaser.Text.addText(0,0, 28, txtColor, fnt,ABCyaPhaser.Localization.instance.getLocalizedString('results_page.correct'), this.reportRowLabelsContainer, true).setOrigin(0.5);

    this.lblQuestions.x = 0;
    this.lblFishCount.x = this.lblQuestions.width + 30;
    this.lblIsCorrect.x = this.lblFishCount.x + this.lblFishCount.width + 60;
    const padding = this.workingWidth - this.reportRowLabelsContainer.getBounds().width;
    this.reportRowLabelsContainer.x = this.lblQuestions.width / 2 + padding / 2;
    this.reportRowLabelsContainer.y = 100;
    this.add(this.reportRowLabelsContainer);

    this.questionNumColumn = this.scene.add.container();
    this.fishCountColumn = this.scene.add.container();
    this.isCorrectColumn = this.scene.add.container();

    const thisData = this.userdata.getCurrentResults() ?? {
      score: 99,
      questionInfo: [
        { questionNum: 1, fishCount: 1, attempts: 1 },
        { questionNum: 2, fishCount: 2, attempts: 1 },
        { questionNum: 3, fishCount: 3, attempts: 2 },
        { questionNum: 4, fishCount: 4, attempts: 1 },
        { questionNum: 5, fishCount: 5, attempts: 1 },
        { questionNum: 6, fishCount: 6, attempts: 2 },
        { questionNum: 7, fishCount: 7, attempts: 1 },
        { questionNum: 8, fishCount: 8, attempts: 1 },
        { questionNum: 9, fishCount: 9, attempts: 1 },
        { questionNum: 10, fishCount: 10, attempts: 1 }
      ]
    };

    const qdata = thisData.questionInfo;
    let curY = 0;
    let totalCorrect = 0;
    let waitTimer = 40;
    for (let i = 0; i < qdata.length; i++) {
      const theqnum = ABCyaPhaser.Text.addText(0, 0, 32, txtColor, fnt, qdata[i].questionNum, this.questionNumColumn,true).setOrigin(0.5);
      theqnum.y = curY;

      const thefishNum = ABCyaPhaser.Text.addText(0, 0, 32, txtColor, fnt, qdata[i].fishCount, this.fishCountColumn,true).setOrigin(0.5);
      thefishNum.y = curY;
      let sn = '';
      if (qdata[i].attempts > 1) {
        sn = UIAssetKeys._ResultMark_incorrect;
      }
      else {
        sn = UIAssetKeys._ResultMark_correct;
        totalCorrect++;
      }
      const markDisplay = ABCyaPhaser.Images.addImage(0, 0, sn, this.isCorrectColumn).setOrigin(0, 0.5);
      markDisplay.y = curY;
      markDisplay.alpha = 0;
      ABCyaPhaser.Tweens.addTween(markDisplay, 220, { delay: waitTimer, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
      waitTimer += 90;
      curY += theqnum.height + 4;
    }
    this.scene.time.delayedCall(waitTimer + 400, this.showScoreMessage, null, this);
    const percent = (totalCorrect / qdata.length) * 100;

    thisData.score = percent;

    this.questionNumColumn.x = this.lblQuestions.x + this.reportRowLabelsContainer.x;
    this.questionNumColumn.y = 160;

    this.fishCountColumn.x = this.lblFishCount.x + this.reportRowLabelsContainer.x;
    this.fishCountColumn.y = 160;

    this.isCorrectColumn.x = this.lblIsCorrect.x + this.reportRowLabelsContainer.x;
    this.isCorrectColumn.y = 160;

    this.add([this.questionNumColumn, this.fishCountColumn, this.isCorrectColumn]);
  }

  showScoreMessage () {
    this.emit('RESULTS_CHART_SHOWN');
  }
}